import { useMemo } from 'react';
import { Badge, Card } from 'react-bootstrap';
import StandardModal from 'components/general/defaultModals/StandardModal';
import { labelTableTopicsPages } from '_helpers/tableTopics';

const FIELDS = [['commend', 'What Went Well'], ['recommend', 'Recommend'], ['overall', 'Overall']];

export default function TableTopicsResultsModal({
  show,
  onHide,
  tableTopics,
  items,
  navigationParent = null,
  agendaItemId = null,
}) {
  const pages = useMemo(() => labelTableTopicsPages(tableTopics.pages, items), [tableTopics.pages, items]);
  const sections = pages.filter(page => !agendaItemId || String(page.agendaItemId) === String(agendaItemId)).map(page => ({
    ...page,
    entries: (tableTopics.reviews || []).flatMap(review => {
      const entry = (review.entries || []).find(item => String(item.agendaItemId) === String(page.agendaItemId));
      return entry ? [{ ...entry, authorName: review.authorName }] : [];
    }),
  })).filter(section => section.entries.length);

  return (
    <StandardModal
      show={show}
      handleClose={onHide}
      title="Table Topics Results"
      navigationParent={navigationParent}
      ModalBodyComponent={sections.length === 0 ? (
        <p className="mb-0">No Table Topics evaluation is available for you yet.</p>
      ) : (
        <div className="table-topics-results d-flex flex-column gap-3">
          {sections.map(section => (
            <Card key={section.agendaItemId} className="text-start">
              <Card.Header>
                <strong>{section.title} - {section.person}</strong>
                {section.topic && <div className="small fst-italic">{section.topic}</div>}
              </Card.Header>
              <Card.Body className="d-flex flex-column gap-3">
                {section.entries.map((entry, index) => (
                  <div key={`${entry.authorName}-${index}`} className="table-topics-result-entry">
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                      <strong>{entry.authorName || 'Member'}</strong>
                      <Badge bg={entry.hasUnpublishedChanges ? 'warning' : entry.publishedAt ? 'success' : 'secondary'}>
                        {entry.hasUnpublishedChanges ? 'Unpublished changes' : entry.publishedAt ? 'Published' : 'Draft'}
                      </Badge>
                    </div>
                    {FIELDS.filter(([key]) => entry[key]).map(([key, label]) => (
                      <p key={key} className="mb-1" style={{ whiteSpace: 'pre-wrap' }}>
                        <span className="fw-semibold">{label}:</span> {entry[key]}
                      </p>
                    ))}
                  </div>
                ))}
              </Card.Body>
            </Card>
          ))}
        </div>
      )}
    />
  );
}
